const COUNTRY_CODES = [
  // 4-digit codes (must come first for correct matching)
  { code: "1876", country: "JM" },
  { code: "1869", country: "KN" },
  { code: "1868", country: "TT" },
  { code: "1864", country: "SH" },
  { code: "1862", country: "AI" },
  { code: "1861", country: "MS" },
  { code: "1859", country: "VG" },
  { code: "1858", country: "TC" },
  { code: "1856", country: "LC" },
  { code: "1854", country: "GD" },
  { code: "1852", country: "HK" },
  { code: "1851", country: "KY" },
  { code: "1849", country: "DO" },
  { code: "1847", country: "AG" },
  { code: "1841", country: "BS" },
  { code: "1829", country: "DO" },
  { code: "1809", country: "DO" },
  { code: "1787", country: "PR" },
  { code: "1784", country: "VC" },
  { code: "1782", country: "CA" },
  { code: "1781", country: "US" },
  { code: "1775", country: "US" },
  { code: "1767", country: "DM" },
  { code: "1758", country: "LC" },
  { code: "1721", country: "SX" },
  { code: "1684", country: "AS" },
  { code: "1671", country: "GU" },
  { code: "1664", country: "MS" },
  { code: "1649", country: "TC" },
  { code: "1284", country: "VG" },
  { code: "1242", country: "BS" },
  { code: "1246", country: "BB" },
  { code: "1264", country: "AI" },
  { code: "1268", country: "AG" },
  { code: "1340", country: "VI" },
  { code: "1345", country: "KY" },
  { code: "1441", country: "BM" },
  { code: "1473", country: "GD" },

  // 3-digit codes
  { code: "998", country: "UZ" },
  { code: "996", country: "KG" },
  { code: "995", country: "GE" },
  { code: "994", country: "AZ" },
  { code: "993", country: "TM" },
  { code: "992", country: "TJ" },
  { code: "991", country: "AC" },
  { code: "976", country: "MN" },
  { code: "975", country: "BT" },
  { code: "974", country: "QA" },
  { code: "973", country: "BH" },
  { code: "972", country: "IL" },
  { code: "971", country: "AE" },
  { code: "970", country: "PS" },
  { code: "968", country: "OM" },
  { code: "967", country: "YE" },
  { code: "966", country: "SA" },
  { code: "965", country: "KW" },
  { code: "964", country: "IQ" },
  { code: "963", country: "SY" },
  { code: "962", country: "JO" },
  { code: "961", country: "LB" },
  { code: "960", country: "MV" },
  { code: "959", country: "MM" },
  { code: "886", country: "TW" },
  { code: "880", country: "BD" },
  { code: "876", country: "JM" },
  { code: "872", country: "PN" },
  { code: "870", country: "PN" },
  { code: "856", country: "LA" },
  { code: "855", country: "KH" },
  { code: "853", country: "MO" },
  { code: "852", country: "HK" },
  { code: "850", country: "KP" },
  { code: "692", country: "MH" },
  { code: "691", country: "FM" },
  { code: "690", country: "TK" },
  { code: "689", country: "PF" },
  { code: "688", country: "TV" },
  { code: "687", country: "NC" },
  { code: "686", country: "KI" },
  { code: "685", country: "WS" },
  { code: "684", country: "AS" },
  { code: "683", country: "NU" },
  { code: "682", country: "CK" },
  { code: "681", country: "WF" },
  { code: "680", country: "PW" },
  { code: "679", country: "FJ" },
  { code: "678", country: "VU" },
  { code: "677", country: "SB" },
  { code: "676", country: "TO" },
  { code: "675", country: "PG" },
  { code: "674", country: "NR" },
  { code: "673", country: "BN" },
  { code: "672", country: "AQ" },
  { code: "670", country: "TL" },
  { code: "599", country: "CW" },
  { code: "598", country: "UY" },
  { code: "597", country: "SR" },
  { code: "596", country: "MQ" },
  { code: "595", country: "PY" },
  { code: "594", country: "GF" },
  { code: "593", country: "EC" },
  { code: "592", country: "GY" },
  { code: "591", country: "BO" },
  { code: "590", country: "BL" },
  { code: "509", country: "HT" },
  { code: "508", country: "PM" },
  { code: "507", country: "PA" },
  { code: "506", country: "CR" },
  { code: "505", country: "NI" },
  { code: "504", country: "HN" },
  { code: "503", country: "SV" },
  { code: "502", country: "GT" },
  { code: "501", country: "BZ" },
  { code: "500", country: "FK" },
  { code: "423", country: "LI" },
  { code: "421", country: "SK" },
  { code: "420", country: "CZ" },
  { code: "389", country: "MK" },
  { code: "387", country: "BA" },
  { code: "386", country: "SI" },
  { code: "385", country: "HR" },
  { code: "383", country: "XK" },
  { code: "382", country: "ME" },
  { code: "381", country: "RS" },
  { code: "380", country: "UA" },
  { code: "378", country: "SM" },
  { code: "377", country: "MC" },
  { code: "376", country: "AD" },
  { code: "375", country: "BY" },
  { code: "374", country: "AM" },
  { code: "373", country: "MD" },
  { code: "372", country: "EE" },
  { code: "371", country: "LV" },
  { code: "370", country: "LT" },
  { code: "359", country: "BG" },
  { code: "358", country: "FI" },
  { code: "357", country: "CY" },
  { code: "356", country: "MT" },
  { code: "355", country: "AL" },
  { code: "354", country: "IS" },
  { code: "353", country: "IE" },
  { code: "352", country: "LU" },
  { code: "351", country: "PT" },
  { code: "350", country: "GI" },
  { code: "299", country: "GL" },
  { code: "298", country: "FO" },
  { code: "297", country: "AW" },
  { code: "291", country: "ER" },
  { code: "290", country: "SH" },
  { code: "269", country: "KM" },
  { code: "268", country: "SZ" },
  { code: "267", country: "BW" },
  { code: "266", country: "LS" },
  { code: "265", country: "MW" },
  { code: "264", country: "NA" },
  { code: "263", country: "ZW" },
  { code: "262", country: "RE" },
  { code: "261", country: "MG" },
  { code: "260", country: "ZM" },
  { code: "258", country: "MZ" },
  { code: "257", country: "BI" },
  { code: "256", country: "UG" },
  { code: "255", country: "TZ" },
  { code: "254", country: "KE" },
  { code: "253", country: "DJ" },
  { code: "252", country: "SO" },
  { code: "251", country: "ET" },
  { code: "250", country: "RW" },
  { code: "249", country: "SD" },
  { code: "248", country: "SC" },
  { code: "247", country: "AC" },
  { code: "246", country: "IO" },
  { code: "245", country: "GW" },
  { code: "244", country: "AO" },
  { code: "243", country: "CD" },
  { code: "242", country: "CG" },
  { code: "241", country: "GA" },
  { code: "240", country: "GQ" },
  { code: "239", country: "ST" },
  { code: "238", country: "CV" },
  { code: "237", country: "CM" },
  { code: "236", country: "CF" },
  { code: "235", country: "TD" },
  { code: "234", country: "NG" },
  { code: "233", country: "GH" },
  { code: "232", country: "SL" },
  { code: "231", country: "LR" },
  { code: "230", country: "MU" },
  { code: "229", country: "BJ" },
  { code: "228", country: "TG" },
  { code: "227", country: "NE" },
  { code: "226", country: "BF" },
  { code: "225", country: "CI" },
  { code: "224", country: "GN" },
  { code: "223", country: "ML" },
  { code: "222", country: "MR" },
  { code: "221", country: "SN" },
  { code: "220", country: "GM" },
  { code: "218", country: "LY" },
  { code: "216", country: "TN" },
  { code: "212", country: "MA" },
  { code: "211", country: "SS" },
  { code: "210", country: "EH" },

  // 2-digit codes
  { code: "98", country: "IR" },
  { code: "95", country: "MM" },
  { code: "94", country: "LK" },
  { code: "93", country: "AF" },
  { code: "92", country: "PK" },
  { code: "91", country: "IN" },
  { code: "90", country: "TR" },
  { code: "86", country: "CN" },
  { code: "84", country: "VN" },
  { code: "82", country: "KR" },
  { code: "81", country: "JP" },
  { code: "66", country: "TH" },
  { code: "65", country: "SG" },
  { code: "64", country: "NZ" },
  { code: "63", country: "PH" },
  { code: "62", country: "ID" },
  { code: "61", country: "AU" },
  { code: "60", country: "MY" },
  { code: "58", country: "VE" },
  { code: "57", country: "CO" },
  { code: "56", country: "CL" },
  { code: "55", country: "BR" },
  { code: "54", country: "AR" },
  { code: "53", country: "CU" },
  { code: "52", country: "MX" },
  { code: "51", country: "PE" },
  { code: "49", country: "DE" },
  { code: "48", country: "PL" },
  { code: "47", country: "NO" },
  { code: "46", country: "SE" },
  { code: "45", country: "DK" },
  { code: "44", country: "GB" },
  { code: "43", country: "AT" },
  { code: "41", country: "CH" },
  { code: "40", country: "RO" },
  { code: "39", country: "IT" },
  { code: "36", country: "HU" },
  { code: "34", country: "ES" },
  { code: "33", country: "FR" },
  { code: "32", country: "BE" },
  { code: "31", country: "NL" },
  { code: "30", country: "GR" },
  { code: "27", country: "ZA" },
  { code: "20", country: "EG" },
];

export const INPUT_PATTERNS = {
  ALL: /./,
  LETTERS: /^[a-zA-Z\s]*$/,
  LETTERS_NO_SPACE: /^[a-zA-Z]*$/,
  PATIENT_NAME: /^[a-zA-ZÀ-ÿ0-9\s'\-]*$/,
  NUMBERS: /^\d*$/,
  ALPHANUMERIC: /^[a-zA-Z0-9\s]*$/,
  ALPHANUMERIC_NO_SPACE: /^[a-zA-Z0-9]*$/,
  DECIMAL: /^[\d.]*$/,
  DECIMAL_NEGATIVE: /^-?[\d.]*$/,
  PHONE: /^[\d\s\+\-\(\)]*$/,
  EMAIL: /^[a-zA-Z0-9@._\-\s]*$/,
  NO_SPECIAL: /^[a-zA-Z0-9\s]*$/,
  CUSTOM: null,
};

export const getDefaultCountryCode = () => {
  try {
    const locale = navigator.language || navigator.userLanguage;
    const country = locale.split("-")[1]?.toUpperCase();

    const localeToCode = {
      GB: "44",
      FR: "33",
      DE: "49",
      IT: "39",
      ES: "34",
      NL: "31",
      BE: "32",
      LU: "352",
      CH: "41",
      AT: "43",
      DK: "45",
      SE: "46",
      NO: "47",
      FI: "358",
      PT: "351",
      PL: "48",
      CZ: "420",
      GR: "30",
      IE: "353",
      IS: "354",
      MT: "356",
      CY: "357",
      BG: "359",
      LT: "370",
      LV: "371",
      EE: "372",
      MD: "373",
      AM: "374",
      BY: "375",
      AD: "376",
      MC: "377",
      SM: "378",
      UA: "380",
      RS: "381",
      ME: "382",
      XK: "383",
      HR: "385",
      SI: "386",
      BA: "387",
      MK: "389",
      SK: "421",
      LI: "423",
    };

    return localeToCode[country] || "352";
  } catch {
    return "352";
  }
};

export const detectCountryCode = phoneNumber => {
  if (!phoneNumber) return null;

  const cleaned = phoneNumber.replace(/[^\d+]/g, "");

  if (cleaned.startsWith("+")) {
    const digits = cleaned.substring(1);
    for (const { code } of COUNTRY_CODES) {
      if (digits.startsWith(code)) {
        return code;
      }
    }
  }

  if (cleaned.startsWith("00")) {
    const digits = cleaned.substring(2);
    for (const { code } of COUNTRY_CODES) {
      if (digits.startsWith(code)) {
        return code;
      }
    }
  }

  return null;
};

export const formatPhoneNumber = (phoneNumber, defaultCountryCode = null) => {
  if (!phoneNumber) return "";

  const userTypedPlus = phoneNumber.trim().startsWith("+");

  let cleaned = phoneNumber.replace(/[^\d+]/g, "").trim();

  if (!cleaned) return "";

  if (cleaned.startsWith("00")) cleaned = "+" + cleaned.substring(2);

  if (!cleaned.startsWith("+")) {
    if (
      defaultCountryCode &&
      !userTypedPlus &&
      cleaned.length >= 7 &&
      cleaned.length <= 11
    ) {
      cleaned = "+" + defaultCountryCode + cleaned;
    } else {
      return phoneNumber;
    }
  }

  if (userTypedPlus && !cleaned.startsWith("+")) cleaned = "+" + cleaned;

  // Extract digits after +
  const digits = cleaned.substring(1);

  if (!digits) return "";

  let countryCode = null;
  let number = "";

  for (const { code } of COUNTRY_CODES) {
    if (digits.startsWith(code) && digits.length > code.length) {
      countryCode = code;
      number = digits.substring(code.length);
      break;
    }
  }

  if (!countryCode) return phoneNumber;

  if (number.length < 4) return phoneNumber;

  const numberGroups = [];
  for (let i = 0; i < number.length; i += 3) {
    const group = number.substring(i, i + 3);
    if (group) {
      numberGroups.push(group);
    }
  }

  let formatted = "+" + countryCode;
  if (numberGroups.length > 0) {
    formatted += " " + numberGroups.join(" ");
  }

  return formatted.substring(0, 20);
};

export const validateEmail = email => {
  if (!email) return null;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = phone => {
  if (!phone) return null;
  const cleanedPhone = phone.replace(/[\s\-\(\)\+]/g, "");
  // Check if it contains only digits and has reasonable length (7-15 digits)
  const phoneRegex = /^\d{7,15}$/;
  return phoneRegex.test(cleanedPhone);
};

export const sanitizeInput = (value, options = {}) => {
  if (value === null || value === undefined) return "";
  const {
    allowedPattern = INPUT_PATTERNS.ALL,
    maxLength = null,
    onInvalidChar = null,
  } = options;

  let pattern = allowedPattern;

  if (typeof allowedPattern === "string")
    pattern = INPUT_PATTERNS[allowedPattern] || INPUT_PATTERNS.ALL;
  if (!(pattern instanceof RegExp)) pattern = INPUT_PATTERNS.ALL;

  let sanitized = String(value);

  // Create a character-level pattern from the full string pattern
  let charPattern = pattern;
  const patternSource = pattern.source;

  if (patternSource.startsWith("^") && patternSource.endsWith("$")) {
    const charClassMatch = patternSource.match(/\[([^\]]+)\]/);
    if (charClassMatch) {
      charPattern = new RegExp(`[${charClassMatch[1]}]`);
    } else {
      const innerPattern = patternSource.slice(1, -1).replace(/\*$/, "");
      if (innerPattern) {
        charPattern = new RegExp(innerPattern);
      }
    }
  }

  sanitized = sanitized
    .split("")
    .filter(char => {
      charPattern.lastIndex = 0;

      let matches = false;
      try {
        matches = charPattern.test(char);
      } catch (err) {
        pattern.lastIndex = 0;
        matches = pattern.test(char);
      }

      if (!matches && onInvalidChar) onInvalidChar(char);

      return matches;
    })
    .join("");

  if (maxLength !== null && typeof maxLength === "number" && maxLength > 0) {
    sanitized = sanitized.substring(0, maxLength);
  }

  return sanitized;
};

export const createSanitizedHandler = (originalOnChange, options = {}) => {
  return e => {
    if (!e || !e.target) {
      if (typeof originalOnChange === "function") {
        originalOnChange(e);
      }
      return;
    }

    if (e.persist && typeof e.persist === "function") {
      e.persist();
    }

    const { value, name } = e.target;
    const { allowedPattern, maxLength, onValidationError } = options;

    // Track if invalid characters were detected
    let invalidCharsDetected = false;
    const sanitizedValue = sanitizeInput(value, {
      allowedPattern,
      maxLength,
      onInvalidChar: () => {
        invalidCharsDetected = true;
      },
    });

    // Validate the sanitized value
    const isValid = validateInputPattern(sanitizedValue, {
      allowedPattern,
      maxLength,
    });

    // Check if max length was exceeded
    const maxLengthExceeded =
      maxLength !== null &&
      typeof maxLength === "number" &&
      value.length > maxLength;

    // Create synthetic event with sanitized value
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: sanitizedValue,
        name: name || e.target.name,
      },
    };

    // Preserve currentTarget if it exists and is different from target
    if (e.currentTarget && e.currentTarget !== e.target) {
      syntheticEvent.currentTarget = {
        ...e.currentTarget,
        value: sanitizedValue,
        name: name || e.currentTarget.name,
      };
    }

    // Handle validation errors
    if (onValidationError && name) {
      if (invalidCharsDetected) {
        let errorMessage = "Invalid characters entered";
        if (
          allowedPattern === INPUT_PATTERNS.LETTERS ||
          allowedPattern === INPUT_PATTERNS.LETTERS_NO_SPACE
        ) {
          errorMessage = "Only letters are allowed";
        } else if (allowedPattern === INPUT_PATTERNS.NUMBERS) {
          errorMessage = "Only numbers are allowed";
        } else if (
          allowedPattern === INPUT_PATTERNS.ALPHANUMERIC ||
          allowedPattern === INPUT_PATTERNS.ALPHANUMERIC_NO_SPACE
        ) {
          errorMessage = "Only letters and numbers are allowed";
        }
        onValidationError(name, errorMessage, { transient: true });
      } else if (maxLengthExceeded) {
        onValidationError(name, `Maximum length is ${maxLength} characters`, {
          transient: true,
        });
      } else if (!isValid && sanitizedValue) {
        onValidationError(name, "Invalid input format");
      } else {
        // Clear error if valid
        onValidationError(name, null);
      }
    }

    // Always call original onChange with sanitized value
    if (typeof originalOnChange === "function") {
      originalOnChange(syntheticEvent);
    }
  };
};

export const validateInputPattern = (value, options = {}) => {
  if (value === null || value === undefined || value === "") return true;

  const { allowedPattern = INPUT_PATTERNS.ALL, maxLength = null } = options;

  let pattern = allowedPattern;
  if (typeof allowedPattern === "string")
    pattern = INPUT_PATTERNS[allowedPattern] || INPUT_PATTERNS.ALL;

  if (!(pattern instanceof RegExp)) pattern = INPUT_PATTERNS.ALL;

  if (
    maxLength !== null &&
    typeof maxLength === "number" &&
    value.length > maxLength
  )
    return false;

  return pattern.test(value);
};

export const normalizeDateInput = dateInput => {
  if (!dateInput) return null;

  if (dateInput instanceof Date) {
    const normalized = new Date(
      dateInput.getFullYear(),
      dateInput.getMonth(),
      dateInput.getDate()
    );
    return isNaN(normalized.getTime()) ? null : normalized;
  }

  const input = String(dateInput).trim();

  if (/^\d{8}$/.test(input)) {
    const year = parseInt(input.substring(0, 4), 10);
    const month = parseInt(input.substring(4, 6), 10);
    const day = parseInt(input.substring(6, 8), 10);
    const date = new Date(year, month - 1, day);

    return date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
      ? date
      : null;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
    const [yearStr, monthStr, dayStr] = input.split("-");
    const year = parseInt(yearStr, 10);
    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const date = new Date(year, month - 1, day);

    return date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
      ? date
      : null;
  }

  const parsed = new Date(input);
  if (isNaN(parsed.getTime())) return null;

  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
};

export const formatDateForInput = date => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatDateToTimestamp = date => {
  const normalized = normalizeDateInput(date);
  if (!normalized) return null;

  const year = String(normalized.getFullYear());
  const month = String(normalized.getMonth() + 1).padStart(2, "0");
  const day = String(normalized.getDate()).padStart(2, "0");

  return `${year}${month}${day}`;
};

export const isDateWithinMax = (dateValue, maxDate) => {
  if (!maxDate) return true;

  const currentDate = normalizeDateInput(dateValue);
  const maxDateParsed = normalizeDateInput(maxDate);

  if (!currentDate || !maxDateParsed) return true;

  return currentDate.getTime() <= maxDateParsed.getTime();
};

export const isDateWithinMin = (dateValue, minDate) => {
  if (!minDate) return true;

  const currentDate = normalizeDateInput(dateValue);
  const minDateParsed = normalizeDateInput(minDate);

  if (!currentDate || !minDateParsed) return true;

  return currentDate.getTime() >= minDateParsed.getTime();
};

/**
 * Sanitizes patient name/surname by removing invalid characters.
 * Allowed characters: a-zA-ZÀ-ÿ0-9\s'\-
 * (letters, accented letters, digits, spaces, hyphens, apostrophes)
 * @param {string} value - The name value to sanitize
 * @returns {string} - Sanitized name with only allowed characters
 */
export const sanitizePatientName = value => {
  if (!value) return value;
  // Strip characters that don't match the PATIENT_NAME pattern
  return value.replace(/[^a-zA-ZÀ-ÿ0-9\s'\-]/g, "");
};
